import { getAt } from '@finn-no/mobility-item-insertion-shared';
import { Controller, type FieldError, type UseControllerProps, useFormContext } from 'react-hook-form';
import type { ComboboxWidgetModel, ValueOption } from '../../../types/widget.js';
import { Combobox } from '../combobox.js';

interface ComboboxWidgetProps extends Omit<ComboboxWidgetModel, 'type'> {
  values: Array<ValueOption>;
}

export const ControlledComboboxWidget = ({
  name,
  helpText,
  rules,
  ...props
}: ComboboxWidgetProps & UseControllerProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = getAt<FieldError>(errors, name);
  if (error) {
    helpText = error.message ?? 'Validation error';
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div data-attribute={name}>
          <Combobox
            name={name}
            label={props.label || ''}
            options={props.values}
            onSelect={(option) => {
              field.onChange(option?.id);
            }}
            onBlur={() => {
              field.onBlur();
            }}
            invalid={!!error}
            helpText={helpText}
            value={field.value}
            className={props.className}
            data-testid={field.name}
          />
        </div>
      )}
      rules={rules}
      shouldUnregister={true}
    />
  );
};
